import _ from 'lodash';

import createBlankError from '../factories/error/create_blank_error';
import createModel, { prop } from './lib/create_model';

const BasicAuthCredentials = createModel({
  modelName: 'LookupApiConfigCredentials',
  properties: {
    username: prop(String),
    password: prop(String),
    realm: prop(String),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export { BasicAuthCredentials };

export default createModel({
  modelName: 'LookupApiConfig',
  properties: {
    credentials: prop(BasicAuthCredentials),
    headers: prop(Object),
    name: String,
    signingKey: prop(String),
    hasPassword: Boolean,
    hasSigningKey: Boolean,
    headerKeys: prop([String]),
    url: prop(String).isRequired,
  },
  statics: {
    create(attrs) {
      return new this(attrs);
    },

    getValidationErrors,
  },
});

function getValidationErrors({ url, signingKey }, errorPrefix) {
  let errors = [];
  if (_.isEmpty(_.trim(url))) {
    errors.push(createBlankError(`${errorPrefix}url`, 'url'));
  }

  if (!_.isUndefined(signingKey) && _.isEmpty(_.trim(signingKey))) {
    errors.push(createBlankError(`${errorPrefix}signingKey`, 'key'));
  }

  return errors;
}



// WEBPACK FOOTER //
// ./src/scripts/domain/models/lookup_api_config.js